import React from 'react';
import { HashRouter as Router, Route, Switch, Redirect } from "react-router-dom";
import routes from "./views/Routes";

export default class App extends React.Component {

  render(){
    return(
        <Router>
            <React.Suspense fallback={null}>
                <Switch>
                {routes.map((route, key) => (
                    <Route
                        key={key}
                        exact={route.exact}
                        path={route.path}
                        render={props => (
                            // pass the sub-routes down to keep nesting
                            <route.component {...props} routes={route.routes} />
                        )}
                    />
                ))}
                <Route path='/' render={() => <Redirect to="/console/user-list" />} />
                </Switch>
            </React.Suspense>
        </Router>
    );
  }
}
